import { createContext, useContext } from 'react';
import { useStore } from 'zustand';

export const BrandStoreContext = createContext(null);

export const useBrandStore = (selector) => {
  const context = useContext(BrandStoreContext);
  if (!context) {
    throw new Error('useBrandStore must be used within a BrandStoreProvider');
  }
  // Allow selector usage, fallback to full state if no selector
  return selector ? useStore(context, selector) : useStore(context);
};

export const BrandStoreProvider = ({ brandStore, children }) => {
  return <BrandStoreContext.Provider value={brandStore}>{children}</BrandStoreContext.Provider>;
};
